/**
 * Feature flags module.
 *
 * Resolution order (highest priority first):
 *   1. VITE env var: VITE_FEATURE_<FLAG_NAME_UPPERCASED>
 *      e.g.  VITE_FEATURE_MY_FEATURE=true
 *   2. localStorage entry: featureFlag:<name>
 *      e.g.  localStorage.setItem('featureFlag:my_feature', 'true')
 *
 * If the env var is present and non-empty it takes precedence over localStorage.
 */

export function getFeatureFlag(name: string): boolean {
  const envKey = `VITE_FEATURE_${name.toUpperCase()}`;
  const envValue = (import.meta.env as Record<string, unknown>)[envKey];
  if (envValue !== undefined && envValue !== '') {
    return envValue === 'true' || envValue === '1' || envValue === true;
  }
  try {
    const lsValue = localStorage.getItem(`featureFlag:${name}`);
    return lsValue === 'true' || lsValue === '1';
  } catch {
    return false;
  }
}
